import { useQuery } from 'react-query';

import useApiHelper from '../../../hooks/useApiHelper';
import { IFaultDefinition } from '../../../types/Fault/FaultDefinition';
import { faultQueryKeys } from '../../QueryKeys';

export default function useSuperAdminFaultDefinitions() {
  const { get } = useApiHelper();

  const faultDefinitions = useQuery({
    queryKey: faultQueryKeys.superAdminDefinitions(),
    queryFn: () =>
      get<{ data: IFaultDefinition[] }>(
        '/v1/superadmin/fault/definitions'
      ).then((res) => res.data.data),
  });

  return {
    faultDefinitions,
  };
}
